import { useState } from 'react'

import { useRentalPortalPageRead } from '../../../../RentalPortal.hooks'
import {
  IMPORT_LOG_FILTER_ALL,
  IMPORT_LOG_PAGE_SIZE,
} from '../../IntegrationsImportLog.constants'
import { getMockImportRuns } from '../../IntegrationsImportLog.mocks'

// TODO: move to useTableLoader once `POST /api/v3/integration/import/runs/filter/` exists; until then the fixture is read here
export function useIntegrationsImportRuns() {
  const [source, setSource] = useState(IMPORT_LOG_FILTER_ALL)
  const [status, setStatus] = useState(IMPORT_LOG_FILTER_ALL)

  async function readRuns({ page, size }) {
    return getMockImportRuns({ page, page_size: size, source, status })
  }

  const runsRead = useRentalPortalPageRead({
    pageSize: IMPORT_LOG_PAGE_SIZE,
    read: readRuns,
    readParams: [source, status],
  })

  function handleSelectStatus(nextStatus) {
    runsRead.changePage(1)
    setStatus(nextStatus)
  }

  function handleSelectSource(nextSource) {
    runsRead.changePage(1)
    setSource(nextSource)
  }

  return {
    ...runsRead,
    handleSelectSource,
    handleSelectStatus,
    source,
    status,
  }
}
